import React from 'react';
import PropTypes from 'prop-types';

export default class Row extends React.Component {

    render() {
        let className = 'row';
        if ( this.props.clearfix ) {
            className += ' clearfix';
        }

        let id = '';
        if ( this.props.id ) {
            id += this.props.id;
        }

        return (
            <div id={id} className={`${className} ${this.props.className}`}>
                {this.props.children}
            </div>
        );
    }

}

Row.propTypes = {
    clearfix: PropTypes.bool,
    id: PropTypes.string,
};

Row.defaultProps = {
    clearfix: false,
    id: '',
};



// WEBPACK FOOTER //
// ./src/app/shared/components/Row.js